import React from "react";

/**
 * R V Ilkal Sarees — original woven monogram.
 * A loom-shuttle diamond with interlaced "R/V" warp threads
 * and the signature Ilkal temple-border chevrons at the base.
 */
export const LogoMark = ({ className = "w-8 h-8", ...props }) => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true" {...props}>
    {/* outer loom diamond */}
    <path d="M32 3 L61 32 L32 61 L3 32 Z" stroke="#BFA15F" strokeWidth="2.5" strokeLinejoin="round" />
    <path d="M32 9.5 L54.5 32 L32 54.5 L9.5 32 Z" stroke="#BFA15F" strokeWidth="1" strokeLinejoin="round" opacity="0.45" />
    {/* interlaced R/V warp threads */}
    <path d="M22 44 V20 h9 a6.5 6.5 0 0 1 0 13 h-9 l15 11" stroke="#6B1C23" strokeWidth="3.4" strokeLinecap="square" strokeLinejoin="round" />
    <path d="M40 20 l4.5 12 4.5-12" stroke="#6B1C23" strokeWidth="2.2" strokeLinecap="square" strokeLinejoin="round" opacity="0.85" />
    {/* temple border chevrons */}
    <path d="M17 49 l4-5 4 5 M25 49 l4-5 4 5 M33 49 l4-5 4 5 M41 49 l4-5 4 5" stroke="#BFA15F" strokeWidth="1.6" strokeLinecap="square" opacity="0.9" />
  </svg>
);
